import axios from "axios";
import { collection, getDocs, addDoc, doc, updateDoc } from "firebase/firestore";
import db from "../../config/firebase";

// initialState
const initialState = {
  client: {},
  user: {},
  level: {},
  room: {},
  category: {},
  reservation: {},
};

// types
const ADD_NEW_CLIENT = "ADD_NEW_CLIENT",
  ADD_NEW_USER = "ADD_NEW_USER",
  ADD_NEW_LEVEL = "ADD_NEW_LEVEL",
  ADD_NEW_ROOM = "ADD_NEW_ROOM",
  ADD_NEW_CATEGORY = "ADD_NEW_CATEGORY",
  ADD_NEW_RESERVATION = "ADD_NEW_RESERVATION";

// reducer
const createReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_NEW_CLIENT":
      return {
        ...state,
        client: action.payload,
      };
    case "ADD_NEW_USER":
      return {
        ...state,
        user: action.payload,
      };
    case "ADD_NEW_LEVEL":
      return {
        ...state,
        level: action.payload,
      };
    case "ADD_NEW_ROOM":
      return {
        ...state,
        room: action.payload,
      };
    case "ADD_NEW_CATEGORY":
      return {
        ...state,
        category: action.payload,
      };
    case "ADD_NEW_RESERVATION":
      return {
        ...state,
        reservation: action.payload,
      };
    default:
      return state;
  }
};

// action
const createClientAction =
  (newClient, dataNames) => async (dispatch, getState) => {
    let clientObject = {};

    dataNames.map((element, index) => {
      clientObject[element] = newClient.get(element);
    });

    const docRef = await addDoc(collection(db, "client"), clientObject)
      .then((response) => {
        clientObject['id'] = response.id;
        // adding to state
        dispatch({
          type: ADD_NEW_CLIENT,
          payload: clientObject,
        });
      })
      .catch((error) => console.log(error));
  };

const createUserAction = (newUser, dataNames) => async (dispatch, getState) => {
  let userObject = {};

  dataNames.map((element, index) => {
    userObject[element] = newUser.get(element);
  });

  const docRef = await addDoc(collection(db, "user"), userObject)
    .then((response) => {
      userObject['id'] = response.id;
      // adding to state
      dispatch({
        type: ADD_NEW_USER,
        payload: userObject,
      });
    })
    .catch((error) => console.log(error));
};

const createLevelAction =
  (newLevel, dataNames) => async (dispatch, getState) => {
    // creating object
    let levelObject = {};

    dataNames.map((element, index) => {
      levelObject[element] = newLevel.get(element);
    });

    levelObject['id'] = Math.floor(Math.random() * 1000000).toString();

    const docRef = await addDoc(collection(db, "level"), levelObject)
      .then((response) => {
        // adding to state
        dispatch({
          type: ADD_NEW_LEVEL,
          payload: levelObject,
        });
      })
      .catch((error) => console.log(error));
  };

const createRoomAction = (newRoom, dataNames) => async (dispatch, getState) => {
  // creating object
  let roomObject = {};

  dataNames.map((element, index) => {
    roomObject[element] = newRoom.get(element);
  });

  const docRef = await addDoc(collection(db, "room"), roomObject)
    .then((response) => {
      roomObject['id'] = response.id;
      // adding to state
      dispatch({
        type: ADD_NEW_ROOM,
        payload: roomObject,
      });
    })
    .catch((error) => console.log(error));
};

const createCategoryAction =
  (newCategory, dataNames) => async (dispatch, getState) => {
    // creating object
    let categoryObject = {};

    dataNames.map((element, index) => {
      categoryObject[element] = newCategory.get(element);
    });

    const docRef = await addDoc(collection(db, "category"), categoryObject)
      .then((response) => {
        categoryObject['id'] = response.id;

        // adding to state
        dispatch({
          type: ADD_NEW_CATEGORY,
          payload: categoryObject,
        });
      })
      .catch((error) => console.log(error));
  };

const createReservationAction =
  (newReservation, dataNames) => async (dispatch, getState) => {
    let reservationObject = {};

    dataNames.map((element, index) => {
      reservationObject[element] = newReservation.get(element);
    });

    const docRef = await addDoc(collection(db, "reservation"), reservationObject)
      .then((response) => {
        reservationObject['id'] = response.id;
        // adding to state
        dispatch({
          type: ADD_NEW_RESERVATION,
          payload: reservationObject,
        });
      })
      .catch((error) => console.log(error));
  };

// export
export {
  createClientAction,
  createUserAction,
  createLevelAction,
  createRoomAction,
  createCategoryAction,
  createReservationAction,
};

export default createReducer;
